import Vue from 'vue'
import Vuex from 'vuex'

import moduleProduct from './module/product'

Vue.use(Vuex);
const state = {
    allowBack:true,
    userInfo: null, // 用户信息
    isLogin: '0',
}

const mutations = {
    // 存储用户信息
    setUserInfo (state, data) {
        state.userInfo = data
        state.isLogin = data.isLogin || '0'
        //console.log(state.isLogin)
    },
    changePurchase(state,purchasList){
        state.purchasList = purchasList
    },
    changeCategoryList(state,categoryList){
        //console.log(categoryList)
        state.categoryList = categoryList
    },
    
}

const actions = {
    setUserInfoAction({commit},data){
        commit('setUserInfo',data);
    },
    purchaseAction({commit},purchasList){
        commit('changePurchase',purchasList);
    },
    categoryListAction({commit},categoryList){
        commit('changeCategoryList',categoryList);
    },
}

export default new Vuex.Store({
    state,
    actions,
    mutations,
    modules:{
        product: moduleProduct
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js